
export default class PredictRange {
  constructor() {
    this.from = 0;
    this.to = 0;
    this.step = 0;
    this.predicts = [];
    this.rangePredicts = [];
  }

  set checked(val) {
    this.predicts.forEach(x => {
      if (this.rangePredicts.includes(x.value)) {
        x.checked = val;
      }
    });
  }

  get checked() {
    return !this.predicts.filter(x => this.rangePredicts.includes(x.value)).some(d => !d.checked);
  }
}